module.exports = __webpack_public_path__ + "media/images/brands/lov_it-ff1a0a229f13513f12ad7d43ca4d465e.jpg";